export const DEFAULT_ERROR_MESSAGE = 'The assistant could not complete your request.';

export const STOPPED_MESSAGE = 'Generation stopped.';

export const RETRY_BUTTON_LABEL = 'Retry';

export const ERROR_ICON_SIZE = 20;
